import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class JobsFilterButtons extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            deleteableButtons: ['.m-jobsFilterButtons__button--roundedRight'],
            clickableButtons: ['.m-jobsFilterButtons__button--clickable'],
            radius: ['.m-jobsFilterButtons__radiusTag'],
            jobFields: ['.m-jobsFilterButtons__jobFieldTag'],
            employmentTypes: ['.m-jobsFilterButtons__employmentTypeTag'],
            jobLevels: ['.m-jobsFilterButtons__jobLevelTag'],
            salary: ['.m-jobsFilterButtons__salaryTag'],
            company: ['.m-jobsFilterButtons__companyTag'],
            homeoffice: ['.m-jobsFilterButtons__homeofficeTag'],
        };
    }

    domEvents() {
        for (let i = 0; i < this.dom.deleteableButtons.length; i += 1) {
            this.dom.deleteableButtons[i].addEventListener('click', (e) => this.buttonClicked(e));
        }
        for (let i = 0; i < this.dom.clickableButtons.length; i += 1) {
            this.dom.clickableButtons[i].addEventListener('click', () => {
                this.events.emit('jobsFilterButtonClicked');
            });
        }
    }

    buttonClicked(e) {
        if (e) e.preventDefault();
        const tagId = e.currentTarget.getAttribute('data-id');
        const tagType = e.currentTarget.getAttribute('data-type');

        if (tagType === 'radius') {
            this.events.emit('radiusRemoved');
        }

        const searchRequest = this.generateSearchRequest(tagId, tagType);
        this.events.emit('changedFilter', { searchRequest });
    }

    generateSearchRequest(tagId, tagType) {
        return {
            radius: tagType === 'radius' ? 0 : this.fillFilterElements(tagId, tagType, this.dom.radius),
            'jobFields[]': this.fillFilterElements(tagId, tagType, this.dom.jobFields),
            'employmentTypes[]': this.fillFilterElements(tagId, tagType, this.dom.employmentTypes),
            'jobLevels[]': this.fillFilterElements(tagId, tagType, this.dom.jobLevels),
            'salary[]': this.fillFilterElements(tagId, tagType, this.dom.salary),
            homeoffice: this.fillFilterElements(tagId, tagType, this.dom.homeoffice),
            company: this.fillInputs(tagId, tagType, this.dom.company),
        };
    }

    fillFilterElements(tagId, tagType, domNodeList) {
        const filters = [];

        for (let i = 0; i < domNodeList.length; i += 1) {
            const id = domNodeList[i].getAttribute('data-id');
            const type = domNodeList[i].getAttribute('data-type');

            if (tagType !== type || tagId !== id) {
                filters.push(id);
            }
        }

        return filters;
    }

    fillInputs(tagId, tagType, domNodeList) {
        let companySlug = false;

        for (let i = 0; i < domNodeList.length; i += 1) {
            const id = domNodeList[i].getAttribute('data-id');
            const type = domNodeList[i].getAttribute('data-type');

            if (tagType !== type || tagId !== id) {
                companySlug = id;
            }
        }

        return companySlug;
    }
}
